<template>
    <div class="col-span-6 mt-5 sm:mt-6" id="additional-people-form">
        <validation-observer ref="observer">
            <div
                v-if="additionalPeopleForm"
                class="col-span-6 block text-sm font-medium text-gray-700"
            >
                <div v-if="indexNumber > 0" class="mt-3 mb-6 border-t border-gray-200"></div>
                <div
                    class="text-left w-full flex justify-start items-center text-gray-400 cursor-pointer mb-4"
                >
                    <span class="font-bold text-gray-700 font-poppins mr-2">
                        {{ memberCount(indexNumber) + " Member" }}
                    </span>
                    <!--<svg v-if="localMemberValidation && false" class='h-5 w-auto flex-shrink-0' xmlns="http://www.w3.org/2000/svg" width="65.729" height="70.107" viewBox="0 0 65.729 70.107">
                        <defs>
                        </defs>
                        <g transform="translate(-16 0.005)">
                            <path class="shield-check-a"
                                d="M77.689,11.453,51.4.5a6.593,6.593,0,0,0-5.053,0L20.053,11.453A6.573,6.573,0,0,0,16,17.523C16,44.7,31.679,63.491,46.331,69.6a6.593,6.593,0,0,0,5.053,0c11.735-4.89,30.345-21.775,30.345-52.075a6.573,6.573,0,0,0-4.04-6.07ZM71.226,27.092l-25.2,25.2a2.2,2.2,0,0,1-3.095,0L28.694,38.047a2.2,2.2,0,0,1,0-3.1l3.095-3.095a2.2,2.2,0,0,1,3.095,0l9.6,9.6L65.036,20.9a2.2,2.2,0,0,1,3.095,0L71.226,24a2.176,2.176,0,0,1,0,3.1Z"
                                transform="translate(0 0)" />
                            <path class="shield-check-b"
                            d="M147.22,154.853l-25.2,25.2a2.2,2.2,0,0,1-3.095,0l-14.241-14.241a2.2,2.2,0,0,1,0-3.1l3.095-3.095a2.2,2.2,0,0,1,3.095,0l9.6,9.6,20.554-20.554a2.2,2.2,0,0,1,3.095,0l3.095,3.095a2.176,2.176,0,0,1,0,3.1Z"
                                transform="translate(-75.994 -127.76)" />
                        </g>
                    </svg>-->
                </div>
            </div>
            <div
                class="row grid gap-6 grid-col-1 md:grid-cols-2"
                v-if="showFormDetails">
                <div class="col">
                    <validation-provider
                        ref="name"
                        name="name"
                        rules="required"
                        v-slot="{ errors }">
                        <label
                            class="block text-sm font-medium text-gray-700"
                            >First Name
                        </label>
                        <input
                            v-model="localName"
                            type="text"
                            name="first_name"
                            id="first_name"
                            autocomplete="given-name"
                            class="mt-1 block w-full rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                            :class="{
                                'border-2 border-red-300 placeholder-red-300':
                                    errors.length,
                                'border border-gray-300': !errors.length,
                            }"
                        />
                        <p class="mt-2 text-sm text-red-600 validation-error" v-if="errors.length">
                            {{ errors[0] }}
                        </p>
                    </validation-provider>
                </div>
                <!-- Last Name Field -->
                <div class="col">
                    <validation-provider
                        ref="surname"
                        name="surname"
                        rules="required"
                        v-slot="{ errors }"
                    >
                        <label
                            class="block text-sm font-medium text-gray-700">
                            Last Name
                        </label>
                        <input
                            v-model="localSurname"
                            type="text"
                            name="last_name"
                            id="last_name"
                            autocomplete="family-name"
                            class="mt-1 block w-full rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                            :class="{
                                'border-2 border-red-300 placeholder-red-300':
                                    errors.length,
                                'border border-gray-300': !errors.length,
                            }"
                        />
                        <p class="mt-2 text-sm text-red-600 validation-error" v-if="errors.length">
                            {{ errors[0] }}
                        </p>
                    </validation-provider>
                </div>
            </div>
            <!-- Date of Birth Fields -->
            <div
                v-if="showFormDetails"
                class="row grid gap-x-6 grid-col-1 md:grid-cols-2 mt-6"
                :class="{
                    'md:mt-4' : additionalPeopleForm
                }"
            >
                <div class="col">
                    <div>
                        <label
                            class="block text-sm font-medium text-gray-700">
                            Date of Birth
                        </label>
                        <label class="text-xs text-gray-500 block mt-2">
                            For example: 27 03 1972
                        </label>
                    </div>
                    <div class="grid grid-cols-3 gap-2 mt-1">
                        <!-- Day -->
                        <validation-provider
                            ref="day"
                            name="day"
                            v-slot="{ errors }"
                        >
                            <input
                                v-model="localDayValue"
                                name="day"
                                type="text"
                                inputmode="numeric"
                                pattern="[0-9]*"
                                placeholder="Day"
                                maxlength="2"
                                @input="moveToNext($event, 'month')"
                                class="col-span-4 sm:col-span-3 block w-full pl-3 py-2 text-base border-gray-300 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm rounded-md"
                                :class="{
                                    'border-2 border-red-300 placeholder-red-300':
                                        errors.length,
                                    'border border-gray-300': !errors.length,
                                }"
                            />
                            <p
                                class="mt-2 text-sm text-red-600 validation-error"
                                v-if="errors.length"
                            >
                                {{ errors[0] }}
                            </p>
                        </validation-provider>
                        <!-- Month -->
                        <validation-provider
                            ref="month"
                            name="month"
                            v-slot="{ errors }"
                        >
                            <input
                                v-model="localMonthValue"
                                name="month"
                                type="text"
                                inputmode="numeric"
                                pattern="[0-9]*"
                                placeholder="Month"
                                maxlength="2"
                                @input="moveToNext($event, 'year')"
                                class="col-span-4 sm:col-span-3 block w-full pl-3 py-2 text-base border-gray-300 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm rounded-md"
                                :class="{
                                    'border-2 border-red-300 placeholder-red-300':
                                        errors.length,
                                    'border border-gray-300': !errors.length,
                                }"
                            />
                            <p
                                class="mt-2 text-sm text-red-600 validation-error"
                                v-if="errors.length"
                            >
                                {{ errors[0] }}
                            </p>
                        </validation-provider>
                        <!-- Year -->
                        <validation-provider
                            ref="year"
                            name="year"
                            v-slot="{ errors }"
                        >
                            <input
                                v-model="localYearValue"
                                name="year"
                                type="text"
                                inputmode="numeric"
                                pattern="[0-9]*"
                                placeholder="Year"
                                maxlength="4"
                                @input="moveToNext($event)"
                                class="col-span-4 sm:col-span-3 block w-full pl-3 py-2 text-base border-gray-300 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm rounded-md"
                                :class="{
                                    'border-2 border-red-300 placeholder-red-300':
                                        errors.length,
                                    'border border-gray-300': !errors.length,
                                }"
                            />
                            <p
                                class="mt-2 text-sm text-red-600 validation-error"
                                v-if="errors.length"
                            >
                                {{ errors[0] }}
                            </p>
                        </validation-provider>
                    </div>
                    <!-- <label v-if="!additionalPeopleForm" class="text-xs text-gray-500 block mt-2">
                        For example: 27 03 1972
                    </label> -->
                    <p v-if="isDateValid" class="mt-2 text-sm text-red-600 validation-error">
                        Invalid Date Of Birth
                    </p>
                    <p v-if="dobError" class="mt-2 text-sm text-red-600 validation-error">
                        The Date of Birth is required
                    </p>
                    <p v-if="isAgeValid" class="mt-2 text-sm text-red-600 validation-error">
                        You must be at least 17 years old.
                    </p>
                </div>
                <div v-if="additionalPeopleForm" class="col">
                    <validation-provider
                        ref="phone"
                        name="phone"
                        :rules="phoneValidationRules"
                        v-slot="{ errors, touched }"
                    >
                        <label class="text-xs text-gray-500"
                            >&nbsp;</label
                        >
                        <label
                            class="block text-sm font-medium text-gray-700">
                            Phone
                        </label>
                        <input
                            v-model="localPhone"
                            type="tel"
                            id="phone"
                            class="mt-1 block w-full rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                            :class="{
                                'border-2 border-red-300 placeholder-red-300':
                                    errors.length,
                                'border border-gray-300': !errors.length,
                            }"
                            @input="localPhone = localPhone.replace(/[A-Za-z]/g, '')"
                        />
                        <p
                            class="mt-2 text-sm text-red-600 validation-error"
                            v-if="errors.length && (touched || localPhone?.length >= 11) && shouldShowUniquePhoneError"
                        >
                            {{ errors[0] }}
                        </p>
                    </validation-provider>
                </div>
                <div class="hidden sm:flex justify-start">
                    <label v-if="additionalPeopleForm" class="text-xs text-gray-500 block">
                        &nbsp;
                    </label>
                </div>
                <div v-if="additionalPeopleForm" class="flex justify-end mt-3 md:mt-2">
                    <a @click.prevent="removeAdditionalPerson()" class="hover:underline text-gray-500 inline-block text-sm font-bold cursor-pointer">
                        Remove Member
                    </a>
                </div>
            </div>
        </validation-observer>
    </div>
</template>

<script>
import { formatPhoneNumber, validateAdditionalPeopleInput } from "../../common/additionalMembersMethods"

export default {
    name: "UserDetails",
    props: {
        name: {
            type: String,
            default: null,
        },
        surname: {
            type: String,
            default: null,
        },
        phone: {
            type: String,
            default: null,
        },
        dayValue: {
            type: String,
            default: "",
        },
        monthValue: {
            type: String,
            default: "",
        },
        yearValue: {
            type: String,
            default: "",
        },
        form: {
            type: Object,
            required: true,
        },
        dateOfBirth: {
            type: Object,
            default: () => ({
                day: { value: "" },
                month: { value: "" },
                year: { value: "" },
            }),
        },
        indexNumber: {
            type: Number,
            default: 0,
        },
        additionalPeopleForm: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            localName: this.name,
            localSurname: this.surname,
            localPhone: this.phone,
            localDayValue: this.dayValue,
            localMonthValue: this.monthValue,
            localYearValue: this.yearValue,
            localDateOfBirth: { ...this.dateOfBirth },
            showFormDetails: true,
            validationRan: false,
            isAgeValid: false,
            isDateValid: false,
            dobError: false,
            localMemberValidation: false
        };
    },
    methods: {
        validateAdditionalPeopleInput,
        moveToNext(event, nextRef) {
            // Accept only numeric input
            event.target.value = event.target.value.replace(/\D/g, '')

            const inputName = event.target.name

            if (inputName === 'day') {
                this.localDayValue = event.target.value
            } else if (inputName === 'month') {
                this.localMonthValue = event.target.value
            } else if (inputName === 'year') {
                this.localYearValue = event.target.value
            }

            // Wait for the DOM to load then check the inputs length has 2 characters before moving onto the next input
            this.$nextTick(() => {
                if (event.target.value.length === 2) {
                    const nextInput = this.$refs[nextRef]?.$el?.querySelector('input')
                    if (nextInput) nextInput.focus()
                }
            })
        },
        async removeAdditionalPerson() {
            
            const updatedPeople = [...this.$store.state.people];

            let data = {};
            data.person = updatedPeople[this.indexNumber];

            if (data.person.id) {
                try {
                    const response = await this.removePersonFromQuoteApi(
                        data,
                        this.$store.state.quote.id
                    );
                    if (response) {
                        updatedPeople.splice(this.indexNumber, 1);
                        this.$store.commit("SET_PEOPLE", updatedPeople);
                    }
                } catch (error) {
                    console.error("Error running remove-people-quote api");
                    alert("Error Removing Person.");
                }
            } else {
                updatedPeople.splice(this.indexNumber, 1);
                this.$store.commit("SET_PEOPLE", updatedPeople);
            }

            

            // this.removePersonFromQuoteApi(data.person, this.$store.state.quote.id)
        },
        validates(silentBol = false) {

            // Reset error flags only if not in silent mode
            if (!silentBol) {
                this.dobError = false;
                this.isDateValid = false;
                this.isAgeValid = false;
            }

            let dobObj = this.localDateOfBirth;

            if (this.additionalPeopleForm) {
                dobObj = {
                    day: {
                        value: this.localDayValue,
                    },
                    month: {
                        value: this.localMonthValue,
                    },
                    year: {
                        value: this.localYearValue,
                    },
                };
            }

            const dateValid = this.dateValidator(dobObj);
            const ageValid = this.ageValidator(dobObj);

            const dobHasInput =
                dobObj.day.value &&
                dobObj.month.value &&
                dobObj.year.value &&
                dobObj.year.value.length > 3;

            // !silentBol is to prevent the error message from being shown on page refresh/load
            if (!dobHasInput) {
                if (!silentBol) {
                    this.dobError = true;
                }
                return false;
            }

            if (dobHasInput) {
                if (!dateValid) {
                    if (!silentBol) {
                        this.isDateValid = true;
                    }
                    return false;
                }

                if (!ageValid) {
                    if (!silentBol) {
                        this.isAgeValid = true;
                    }
                    return false;
                }
            }

            if (!silentBol) {
                this.validationRan = true;
            }
            
            return true;
        },
        validateUserInputs() {
            const accountHolderPhoneNumber = this.form.phone ?? this.form.customer.phone

            const formattedPerson = {
                name: this.localName,
                surname: this.localSurname,
                phone: this.localPhone
            }

            validateAdditionalPeopleInput(formattedPerson, accountHolderPhoneNumber, false)
        },
        memberCount(index) {
            const labels = ["Second", "Third", "Fourth"]
            return labels[index]
        },
        async triggerValidation(silentBol = false) {
            if (this.$refs.observer) {
                // silent = false, error messages will be shown
                const veeValidateResult = await this.$refs.observer.validate({ silent: silentBol });
                const validateDob = this.validates(silentBol)
                this.localMemberValidation = veeValidateResult && validateDob
                return this.localMemberValidation
            } else {
                this.localMemberValidation = false
                return false
            }
        },
    },
    computed: {
        allPhones() {
            const phones = [this.form.phone.value || ''];
            this.$store.state.people.forEach(person => {
                phones.push(person.phone?.value || '');
            });
            return phones;
        },
        phoneValidationRules() {
            return {
                required: true,
                uk_number: {
                    min: 11, // min length is 11 for UK mobile numbers - personal package validation rule
                    max: 11
                },
                mobile_only_personal_cover: {
                    coverType: this.form?.cover_type?.value
                },
                unique_phone: {
                    allPhones: this.allPhones,
                    currentIndex: this.indexNumber + 1,
                    coverType: this.form?.cover_type?.value
                }
            };
        },
        shouldShowUniquePhoneError() {
            // function to show highest index with dupe phone number without affecting svg shield validation - comes from vee-validate-rules.js
            
            // Always show non-unique_phone errors
            const phoneRef = this.$refs.phone;
            if (!phoneRef || !phoneRef.errors.length) {
                return true;
            }
            
            // Check if this is a unique_phone error
            const hasUniquePhoneError = phoneRef.errors.some(error => 
                error.includes('already in use')
            );

            // If not a unique_phone error, show it
            if (!hasUniquePhoneError) {
                return true;
            }
            
            // For unique_phone errors, only show on the highest index with this number
            if (!this.localPhone || this.form?.cover_type?.value !== 'personalCover') {
                return false;
            }
            

            const cleanedValue = formatPhoneNumber(this.localPhone);
            
            const currentLast10 = cleanedValue.slice(-10);
            
            let highestDuplicateIndex = -1;
            

            this.allPhones.forEach((phone, index) => {
                if (!phone) return;
                const phoneCleanedValue = formatPhoneNumber(String(phone));
                const phoneLast10 = phoneCleanedValue.slice(-10);
                
                if (phoneLast10 === currentLast10) {
                    highestDuplicateIndex = Math.max(highestDuplicateIndex, index);
                }
            });
            
            // Only show error if this is the highest index with dupe phone number
            const currentIndex = this.indexNumber + 1;
            return currentIndex === highestDuplicateIndex;
        }
    },
    mounted() {
        this.triggerValidation(true)
    },
    watch: {
        localName(newVal) {
            this.$emit("update:name", newVal);
            if (this.additionalPeopleForm) {
                this.validateUserInputs()
                this.$nextTick(() => this.triggerValidation())
            }
        },
        localSurname(newVal) {
            this.$emit("update:surname", newVal);
            if (this.additionalPeopleForm) {
                this.validateUserInputs()
                this.$nextTick(() => this.triggerValidation())
            }
        },
        localPhone(newVal) {
            this.$emit("update:phone", newVal);
            if (this.additionalPeopleForm) {
                this.validateUserInputs()
                this.$nextTick(() => this.triggerValidation())
            }
        },
        localDayValue(newVal) {
            this.$emit("update:day", newVal);
            if (this.additionalPeopleForm) {
                this.$nextTick(() => this.triggerValidation())
            }
        },
        localMonthValue(newVal) {
            this.$emit("update:month", newVal);
            if (this.additionalPeopleForm) {
                this.$nextTick(() => this.triggerValidation())
            }
        },
        localYearValue(newVal) {
            this.$emit("update:year", newVal);
            if (newVal.length == 4 && this.localDayValue.length == 2 && this.localMonthValue.length == 2) {
                this.validates()
                if (this.additionalPeopleForm) {
                    this.validateUserInputs()
                    this.$nextTick(() => this.triggerValidation())
                }
            } else if (this.additionalPeopleForm) {
                this.$nextTick(() => this.triggerValidation())
            }
        },
        // Watch the allPhones array to re-validate when other members' phones change
        allPhones: {
            handler() {
                if (this.additionalPeopleForm && this.localPhone) {
                    this.$nextTick(() => this.triggerValidation())
                }
            },
            deep: true
        }
    },
};
</script>
